import { render, staticRenderFns } from "./UpdateProductSidebar.vue?vue&type=template&id=ace4e974&scoped=true&lang=pug&"
import script from "./UpdateProductSidebar.vue?vue&type=script&lang=js&"
export * from "./UpdateProductSidebar.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./UpdateProductSidebar.vue?vue&type=style&index=1&id=ace4e974&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ace4e974",
  null
  
)

export default component.exports